// extracted by mini-css-extract-plugin
module.exports = {"CancelButton":"ButtonPanel_CancelButton__3RYUp","Buttons":"ButtonPanel_Buttons__3iEIM"};